module.exports = __webpack_public_path__ + "screenshot-752460e373ba6c7519109936bd0656f6.jpg";